

const RivaahCatalog = () => {
  return  <iframe
      src="https://publuu.com/flip-book/681532/2143475/page/2?embed"
      width="100%"
      className="publuuflip h-[100vh] md:h-[100vh]"
      scrolling="no"
      frameBorder="0" 
      allow="clipboard-write; autoplay; fullscreen"
      title="Publuu Flipbook"
    ></iframe>
}

export default RivaahCatalog;